// Reason, weird mix of node and non-node enviroment variables.
/* eslint-disable @typescript-eslint/no-explicit-any */

import { Injectable, Scopes } from '@visiba/instantiation';

interface AnalyticMeta {
	url: string;
	siteId: number;
}

interface AnalyticConfigPresent {
	enabled: true;
	meta: Readonly<AnalyticMeta>;
}

interface AnalyticConfigDisabled {
	enabled: false;
	meta: null;
}

type AnalyticConfig = AnalyticConfigPresent | AnalyticConfigDisabled;

interface Environment {
	api: {
		uri: string | null;
	};
	realtime: {
		host: string | null;
		port: string;
	};
	analyticConfig: AnalyticConfig;
	serverBaseUrl: string;
	cdn: {
		customer: string;
		media: string;
	};
}

@Injectable({
	scope: Scopes.Singleton,
})
export class HostingService {
	public wsBaseUri: string;
	public apiBaseUri: string;
	public readonly isDev_DONT_USE_IT_ONLY_EXIST_TO_MAKE_ANGULAR_WORK: boolean;
	public readonly assetPath: string;
	public readonly mediaCdn: string;
	public readonly customerCdn: string;
	public readonly location: string;
	public readonly analyticConfig: AnalyticConfig;

	constructor() {
		// We're doing a bit of tomfoolery here to get the environment variables from the Vite environment or Webpack environment.
		// Very cool, very epic. Let's hope we can get rid of this soon...
		this.isDev_DONT_USE_IT_ONLY_EXIST_TO_MAKE_ANGULAR_WORK =
			import.meta.env != null ? (import.meta.env as any).DEV : process.env.NODE_ENV === 'development';
		const VITE_HOSTING_API_URL =
			import.meta.env != null ? import.meta.env.VITE_HOSTING_API_URL : (process?.env as any)?.CUSTOM_GLOBAL_ENV?.API_URL;
		const VITE_HOSTING_REALTIME_HOST =
			import.meta.env != null ? import.meta.env.VITE_HOSTING_REALTIME_HOST : (process?.env as any)?.CUSTOM_GLOBAL_ENV?.REALTIME_HOST;
		const VITE_HOSTING_REALTIME_PORT =
			import.meta.env != null ? import.meta.env.VITE_HOSTING_REALTIME_PORT : (process?.env as any)?.CUSTOM_GLOBAL_ENV?.REALTIME_PORT;
		const VITE_BASE_RULE = import.meta.env != null ? ((import.meta.env.VITE_BASE_RULE ?? '') as string) : '/PublicV3/assets';

		const config: Environment = this.isDev_DONT_USE_IT_ONLY_EXIST_TO_MAKE_ANGULAR_WORK
			? {
					api: {
						uri: VITE_HOSTING_API_URL ?? 'https://dev1.vcare.pl',
					},
					realtime: {
						host: VITE_HOSTING_REALTIME_HOST ?? 'dev1.vcare.pl',
						port: VITE_HOSTING_REALTIME_PORT ?? (443).toString(),
					},
					analyticConfig: {
						enabled: true,
						meta: {
							url: '//analytics.visibacare.com/',
							siteId: 7,
						},
					},
					serverBaseUrl: VITE_BASE_RULE,
					cdn: {
						customer: '//customer-cdn.visibacare.com',
						media: '//media-cdn.visibacare.com',
					},
				}
			: {
					api: {
						uri: null,
					},
					realtime: {
						host: null,
						port: '443',
					},
					analyticConfig: this.getAnalyticConfig(),
					serverBaseUrl: VITE_BASE_RULE,
					cdn: {
						customer: '//customer-cdn.visibacare.com',
						media: '//media-cdn.visibacare.com',
					},
				};

		this.location = config.api.uri ?? globalThis.location.origin;
		this.assetPath = config.serverBaseUrl;
		this.mediaCdn = config.cdn.media;
		this.customerCdn = config.cdn.customer;
		this.apiBaseUri = `${this.location ?? ''}/api`;
		this.wsBaseUri = `wss://${config.realtime.host ?? location.hostname}:${config.realtime.port}`;
		this.analyticConfig = config.analyticConfig;
	}

	private getAnalyticConfig(): AnalyticConfig {
		let siteId: number;

		if (location.hostname.includes('vcare.pl') || location.hostname.includes('stage-service.visibacare')) {
			siteId = 7; // 7 == New patient web (DEV) siteId in Matomo
		} else {
			siteId = 12; // 12 == New patient web (Prod) siteId in Matomo
		}

		return {
			enabled: true,
			meta: {
				url: '//analytics.visibacare.com/',
				siteId: siteId,
			},
		};
	}
}
